// === FRONTEND COMPONENT (React + MUI v3, Styled) ===

import { useEffect, useState } from "react";
import axios from "axios";
import * as d3 from "d3";
import {
  Box,
  Typography,
  Card,
  CardContent,
  CircularProgress,
} from "@mui/material";
import LineChart from "../components/LineChart.jsx";

const headers = ['Last Month', 'Current Month']

export default function MetricsDashboard() {
  const [metrics, setMetrics] = useState(null);
  const [loading, setLoading] = useState(true);
  const [actualGainData, setActualGainData] = useState([]);

/*   useEffect(() => {
    const fetchMetrics = async () => {
      try {
        const res = await axios.get("http://localhost:5000/metrics");
        setMetrics(res.data);
      } catch (error) {
        console.error("Failed to fetch metrics", error);
      } finally {
        setLoading(false);
      }
    };
    const actualGainChart = async () => {
      try {
        const res = await axios.get("http://localhost:5000/metrics/daily");

        // Parse dates and numbers
        const parsedData = res.data.data.map(d => ({
          date: d3.timeParse("%Y-%m-%d")(d.sk),
          actualGain: d.totalActualGain
          || 0,
        }));
        setActualGainData(parsedData);
      } catch (error) {
        console.error("Error fetching daily metrics", error);
      }
    };
    actualGainChart()
    fetchMetrics();
  }, []); */

  if (loading) return (
    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "60vh" }}>
      <CircularProgress />
    </Box>
  );

  const { monthly, meta } = metrics.metrics;
  const sortedMonthly = [...monthly].sort((a, b) => {
    const [aYear, aMonth] = a.sk.split("-").map(Number);
    const [bYear, bMonth] = b.sk.split("-").map(Number);
    return aYear !== bYear ? aYear - bYear : aMonth - bMonth;
  });

  return (
    <div>
      {metrics && <div>
      <Box sx={{ display: 'flex', gap: 4, flexWrap: 'nowrap', overflowX: 'auto', p: 4 }}>
        <Box sx={{ display: 'flex', gap: 2 }}>
          {sortedMonthly.map((month, i) => (
            <Card
              key={`${month.month}_${i}`}
              sx={{ minWidth: 250, flex: '0 0 auto', borderRadius: 3, boxShadow: 3 }}
            >
              <CardContent>
                <Typography variant="h6" gutterBottom>{headers[i]}</Typography>
                <Typography variant="h6" sx={{ mb: 1 }}>{month.month}</Typography>
                <Typography variant="body2">🧮 FIFO Gain: <strong>${month.totalFifoGain}</strong></Typography>
                <Typography variant="body2">💰 Actual Gain: <strong>${month.totalActualGain}</strong></Typography>
                <Typography variant="body2">🧾 Tax (FIFO): ${month.totalTaxFifo}</Typography>
                <Typography variant="body2">🧾 Tax (Actual): ${month.totalTaxActual}</Typography>
                <Typography variant="body2">📤 Sells: {month.transactionCount}</Typography>
              </CardContent>
            </Card>
          ))}
        </Box>

      <Card sx={{ minWidth: 280, flex: '0 0 auto', borderRadius: 3, boxShadow: 3 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>All-Time Summary</Typography>
          <Typography variant="body2">📊 Total FIFO Gain: <strong>${meta.totalFifoGain}</strong></Typography>
          <Typography variant="body2">💰 Total Actual Gain: <strong>${meta.totalActualGain}</strong></Typography>
          <Typography variant="body2">🧾 Total Tax FIFO: ${meta.totalTaxFifo}</Typography>
          <Typography variant="body2">🧾 Total Tax Actual: ${meta.totalTaxActual}</Typography>
          <Typography variant="body2">📤 Total Sells: {meta.transactionCount}</Typography>
        </CardContent>
      </Card>
    </Box>
    <Box>
      <Typography variant="h5" gutterBottom>📈 Daily Actual Gain</Typography>
      <LineChart data={actualGainData}/>
    </Box>
    </div>}
  </div>
  );
}
